module.exports = __webpack_public_path__ + "static/media/secondary_23-24.f23d6691.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/secondary_23-24.png
// module id = 244
// module chunks = 0